import React from 'react';
import { useSelector } from 'react-redux';

import fullscreenEnterIcon from '../../../../../../assets/img/fullscreen-enter.png';
import { RootState } from '../../../../../../store';

interface TimelinePopupHeaderProps {
  closeInsightDetails: () => void;
  insightDetailsContent: any;
  gotoMedSettings: () => void;
}
const TimelinePopupHeader = ({
  closeInsightDetails,
  gotoMedSettings,
  insightDetailsContent,
}: TimelinePopupHeaderProps) => {
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const isAbleToViewAllInsights = React.useMemo(() => {
    if (!selectedTenancy?.features?.patientProfileTabSettings) {
      return true;
    }
    return Boolean(
      selectedTenancy?.features?.patientProfileTabSettings
        ?.showInsightsAndActions,
    );
  }, [selectedTenancy?.features?.patientProfileTabSettings]);
  return (
    <>
      <button
        type="button"
        className="btn-close"
        style={{ marginRight: 'auto' }}
        aria-label="Close"
        onClick={closeInsightDetails}
      />
      {isAbleToViewAllInsights &&
        insightDetailsContent.group_type === 'Insights' && (
          <button className="btn btnPrimary btn-sm">View all insights</button>
        )}
      {insightDetailsContent.settings?.dosageChange && (
        <button className="btn btnPrimary btn-sm" onClick={gotoMedSettings}>
          View medication settings
          <img
            style={{ paddingLeft: '10px', paddingRight: '5px' }}
            alt=""
            src={fullscreenEnterIcon}
          />
        </button>
      )}
    </>
  );
};

export default TimelinePopupHeader;
